//? ESLint is disabled so that the constants remain on a single line.
/* eslint-disable */

export const IS_DEVELOPMENT_ENV =
  !process.env.NODE_ENV || process.env.NODE_ENV === "development";

//? domains
export const DOMAIN_BETA = "webapp-beta.shipnow.com.ar";
export const DOMAIN_LOCALHOLST = "localhost";
export const DOMAIN_SHIPNOW = "shipnow.com.ar";
export const DOMAIN_SHIPNOW_APP = "app.shipnow.com.ar";

//? constants for list pages.
export const LIST_PAGE_SIZE = 25;
export const LIST_DUMB = new Array(LIST_PAGE_SIZE).fill({});
export const LIST_REFRESH_INTERVAL = 300000; //? Value in milliseconds, equivalent to 5 minutes.

export const PULLING_INTERVAL = 5000; //? Value in milliseconds, equivalent to 5 seconds.

//? apis constants
export const CLOUDINARY_URL =
  "https://api.cloudinary.com/v1_1/cloud9/image/upload";

//? keyboard debounce
export const KEYBOARD_DEBOUNCE = 1000;

//? doc types
export const DOC_TYPES_LIST = ["DNI", "CUIT", "CUIL", "Pasaporte"];

//? post office quantity
export const POST_OFFICE_QUANTITY = 10;

//? argentina state
export const ARGENTINA_STATES = [
  "Ciudad Autónoma de Buenos Aires",
  "Buenos Aires",
  "Catamarca",
  "Chaco",
  "Chubut",
  "Córdoba",
  "Corrientes",
  "Entre Ríos",
  "Formosa",
  "Jujuy",
  "La Pampa",
  "La Rioja",
  "Mendoza",
  "Misiones",
  "Neuquén",
  "Río Negro",
  "Salta",
  "San Juan",
  "San Luis",
  "Santa Cruz",
  "Santa Fe",
  "Santiago del Estero",
  "Tierra del Fuego",
  "Tucumán",
];
